import historyStore from './store'

export default class HistoryModule {
  name = 'history'
  constructor({ store }) {
    store.registerModule(this.name, historyStore)
  }
}
